module.exports = __webpack_public_path__ + "static/media/Golf-Ridge-Villas-MasterDeed.eff425b2.pdf";